import { render, staticRenderFns } from "./drinks.vue?vue&type=template&id=35253833&scoped=true&"
import script from "./drinks.vue?vue&type=script&lang=js&"
export * from "./drinks.vue?vue&type=script&lang=js&"
import style0 from "./drinks.vue?vue&type=style&index=0&id=35253833&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35253833",
  null
  
)

export default component.exports